<template>
    <ModalContainer :show="show" @close="onCancel">
      <template slot="header">
        <h4 class="mb-0 text-capitalize">{{ $t("logistics") }}</h4>
      </template>
      <template slot="body">
        <div class="form-group w-100">
          <label for="logisticsType">{{ $t("logistics") }}</label>
          <select
            class="form-control text-capitalize"
            style="height: 50px"
            v-model="selectedLogisticsType"
            id="logisticsType"
            required
          >
            <option value="" disabled>{{ $t("select") }} {{ $t("Logistics") }}</option>
            <option
              v-for="logisticsType in logisticsTypes"
              :value="logisticsType"
              :key="logisticsType"
            >
              {{ logisticsType }}
            </option>
          </select>
        </div>
      </template>
      <template slot="footer">
        <div style="display: flex; justify-content: end">
          <button type="submit" class="btn btn-primary text-capitalize" @click="onSave">
            {{ $t("next") }}
          </button>
        </div>
      </template>
    </ModalContainer>
  </template>
  
  <script>
  import ModalContainer from "../../components/ModalContainer.vue";
  
  export default {
    name: "LogisticsTypeModal",
    components: {
      ModalContainer,
    },
    props: {
      show: Boolean,
      onCancel: Function,
      initialLogisticsType: String,
    },
    data() {
      return {
        selectedLogisticsType: this.initialLogisticsType || "",
        logisticsTypes: [this.$t("internal"), this.$t("external")],
      };
    },
    methods: {
      onSave() {
        this.$emit("save", this.selectedLogisticsType);
      },
    },
  };
  </script>
  
  <style scoped>
  .form-group {
    margin-bottom: 1rem;
  }
  </style>
  